import React from "react";

const BookmarkOutlineIcon = ({ width,isOutline, height }) => {
  return (
    <>
      {isOutline ? (
        <svg width={width} height={height} viewBox="0 0 28 37" fill="none">
          <path
            d="M0 36.25V3C0 2.2 0.3 1.5 0.9 0.9C1.5 0.3 2.2 0 3 0H25C25.8 0 26.5 0.3 27.1 0.9C27.7 1.5 28 2.2 28 3V36.25L14 30.25L0 36.25ZM3 31.7L14 27.05L25 31.7V3H3V31.7Z"
            fill="black"
          />
        </svg>
      ) : (
        <svg width={width} height={height} viewBox="0 0 28 37" fill="none">
          <path
            d="M0 36.25V3C0 2.2 0.3 1.5 0.9 0.9C1.5 0.3 2.2 0 3 0H25C25.8 0 26.5 0.3 27.1 0.9C27.7 1.5 28 2.2 28 3V36.25L14 30.25L0 36.25Z"
            fill="black"
          />
        </svg>
      )}
    </>
  );
};

BookmarkOutlineIcon.defaultProps = {
  width: 15,
  height: 20,
  fill: "black",
};

export default BookmarkOutlineIcon;
